<template lang="pug">
  v-row#filter-col-padding(no-gutters)
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='searchBarText'
        :placeholder="$t('eventAuthHistoryFilter.searchForWord')"
        prepend-inner-icon='mdi-magnify')
    v-col(cols='12')
      .textLabel.colorGrey
        | {{$t('eventAuthHistoryFilter.lookForTheConversationIdentificationProtocol')}}
      v-text-field(
        hide-details
        filled
        dense
        v-model='protocol'
        placeholder='Protocolo')
    v-col(cols='12' style='padding-bottom: 0;')
      .textLabel.colorDark(style='margin-top: 12px;')
        | {{$t('eventAuthHistoryFilter.userFields')}}
      .textLabel.colorGrey
        | {{$t('eventAuthHistoryFilter.searchForUsernameAndCpf')}}
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='user_name'
        :placeholder="$t('eventAuthHistoryFilter.username')"
        prepend-inner-icon='mdi-account-outline')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='cpfMasked'
        v-mask='["###.###.###-##", "##.###.###/####-##"]'
        placeholder='CPF'
        prepend-inner-icon='mdi-card-account-details-outline')
    v-col(cols='12' style='padding-bottom: 0;')
      .textLabel.colorDark(style='margin-top: 12px;')
        | {{$t('eventAuthHistoryFilter.conversationFields')}}
      .textLabel.colorGrey
        | {{$t('eventAuthHistoryFilter.searchByQueueNameOperatorNameLoginChannelAuthentication')}}
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='group_name'
        :placeholder="$t('eventAuthHistoryFilter.queueName')"
        prepend-inner-icon='mdi-account-group')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='operator_name'
        :placeholder="$t('eventAuthHistoryFilter.operatorName')"
        prepend-inner-icon='mdi-account-outline')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='operator_login'
        :placeholder="$t('eventAuthHistoryFilter.operatorLogin')"
        prepend-inner-icon='mdi-account-outline')
    v-col(cols='12')
      v-select(
        hide-details
        filled
        dense
        clearable
        :placeholder="$t('eventAuthHistoryFilter.channel')"
        v-model='channelFilter'
        :items='channels'
        prepend-inner-icon='mdi-web'
        clear-icon='mdi-close'
        append-icon='mdi-chevron-down')
    v-col(cols='12')
      v-select(
        hide-details
        filled
        dense
        clearable
        :placeholder="$t('eventAuthHistoryFilter.authenticationType')"
        v-model='authenticated_type'
        :items='listAutenticated'
        prepend-inner-icon='mdi-card-account-details-outline'
        clear-icon='mdi-close'
        append-icon='mdi-chevron-down')
    v-col(cols='12' style='padding-bottom: 0;')
      .textLabel.colorDark(style='margin-top: 12px;')
        | {{$t('eventAuthHistoryFilter.auditFields')}}
      .textLabel.colorGrey
        | {{$t('eventAuthHistoryFilter.searchForTheNameOrLoginOfThePerson')}}
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='user'
        :placeholder="$t('eventAuthHistoryFilter.platformUserNameOrLogin')"
        prepend-inner-icon='mdi-account-outline')
    //- v-col
    //-   v-btn(color='#9c27b0' dark rounded @click='changeFilters()' style='float: right') Aplicar
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  computed: {
    ...mapFields('eventAuthHistoryFilter', ['searchBarText', 'protocol', 'dateIntervalFilter', 'user_name', 'cpf', 'group_name', 'operator_name', 'operator_login', 'channelFilter', 'authenticated_type', 'user']),
    ...mapGetters('workspaces', ['active']),
    ...mapGetters('snapshots', ['appliedSnapshot']),
    hasActiveWorkspace () {
      return this.active ? (this.appliedSnapshot ? 1 : 0) : 0
    }
  },
  watch: {
    cpfMasked (nV) {
      this.cpf = nV.replace('.', '').replace('-', '').replace('/', '').replace('.', '')
    },
    phoneMasked (nV) {
      this.phone = nV.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
    }
  },
  data () {
    return {
      channels: ['webclient', 'whatsapp', 'teams', 'facebook', 'telegram'],
      listAutenticated: [{
        text: 'Govbr',
        value: 'Govbr'
      },
      {
        text: this.$t('eventAuthHistoryFilter.noAuthentication'),
        value: 'no_authenticated'
      }],
      intents: [],
      cpfMasked: undefined,
      phoneMasked: undefined
    }
  },
  methods: {
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    async getIntents () {
      const result = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/snapshots`, {
        params: {
          workspace: this.active.id,
          status: 'published',
          fields: 'data.intents.intent'
        }
      })
      this.intents = result.data.data[0]._source.data.intents.map((obj) => obj.intent)
    }
  },
  mounted () {
    if (this.hasActiveWorkspace) {
      this.getIntents()
    }
  }
}
</script>

<style>
.v-input__prepend-inner {
  margin-right: auto;
  padding-right: 8px;
}
#filter-col-padding .col {
  padding: 8px;
}
</style>
